import { ArrowForwardIosRounded } from '@mui/icons-material';
import { Box, Button, List, ListItemText, Stack } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';
import { memo, useState } from 'react';

const InstructionsSection = () => {
    const instructions = [
        {
            key: 'navigate',
            title: 'Navigate across locations and features',
        },
    ];

    const [selectedInstructions, setSelectedInstructions] = useState(instructions[0].key);

    const NavigateInstruction = memo(
        () => (
            <>
                <p className={styles['instruction-header']}>Asset Search</p>
                <List className={styles['ordered-list']}>
                    <ListItemText className={styles['list-item']}>
                        <span>Use the location selector at the top to switch between facilities.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>Click on sections (like Appointments or Inventory List) to explore more detailed views.</span>
                    </ListItemText>
                    <ListItemText className={styles['list-item']}>
                        <span>The dashboard updates in near real-time; refresh if data appears outdated.</span>
                    </ListItemText>
                </List>
            </>
        ),
        []
    );
    NavigateInstruction.displayName = 'AssetSearchInstructions';

    const getInstructionsComponent = (key) => {
        switch (key) {
            case 'navigate':
                return <NavigateInstruction />;
        }
    };
    return (
        <>
            <h4>INSTRUCTIONS</h4>
            <Box display="flex" flexDirection="row" boxSizing="border-box" height="24rem" width="100%">
                <Box className={styles['instruction-title-container']}>
                    <Stack spacing={2}>
                        {instructions.map((instruction) => (
                            <Button
                                key={instruction.key}
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                    setSelectedInstructions(instruction.key);
                                }}
                                className={`${styles['instruction-button']}
                          ${selectedInstructions === instruction.key ? styles['instruction-button--selected'] : ''}`}
                                disableRipple
                            >
                                {instruction.title}
                                <ArrowForwardIosRounded className={styles['arrow-right']} />
                            </Button>
                        ))}
                    </Stack>
                </Box>
                <Box className={styles['instruction-content-container']}>{getInstructionsComponent(selectedInstructions)}</Box>
            </Box>
        </>
    );
};

export default InstructionsSection;
